export default {
  terminals: 'Terminals',
  searchPlaceholder: 'Search by name',
  terminalId: 'Terminal ID',
  cardTerminalId: 'Terminal ID',
  location: 'Location',
  account: 'Account',
  lastActivity: 'Last activity',
  linkedPhone: 'Linked phone',
  lastTransaction: 'Last transaction',
  addTerminal: 'Add terminal',
  device: 'Device',
  makeInactive: 'Make inactive',
  applicationId: 'Application ID',
  deviceLabel: 'Device label',
  OS: 'OS',
  enrolledAt: 'Enrolled at',
  linkedEmployees: 'Linked employees',
  label: 'Label',
  type: 'Type',
  MPOS: 'mPOS',
  ECOMMERCE: 'e-Commerce',
  phoneNumber: 'Phone number',
  additionalData: 'Additional data',
  editTerminal: 'Edit terminal',
  changeTerminalLocation: 'Change terminal location',
  noDevice: 'Not linked to any device',
  issueActivationCode: 'Issue activation code',
  issueActivationCodeFor: 'Issue activation code for "{{name}}"',
  noPhone: 'No phone number',
  activationCode: 'Activation code ({{status}})',
  validTill: 'Valid till',
  lastCode: 'Last code',
  newCodeReceived: 'New code received',
  NFCTerminal: 'NFC Terminal',
  linkedAccounts: 'Linked account(s)',
  notDefined: 'Not defined',
  deletedTerminal: 'Deleted terminal',
  // card-pos
  model: 'Model',
  softwareName: 'Software name',
  paymentSchemas: 'Payment schema',
  softwareVersion: 'Software version',
  qrPaymentsEnabled: 'QR payment enabled',
  'View Terminals': 'View Terminals',
  integration: 'Integration',
  apiKey: 'API Key',
  tokenPrefix: 'Token prefix',
  dateOfCreation: 'Date of creation',
  issueApiKey: 'Issue API Key',
  revokeApiKey: 'Revoke API Key',
  yourApiKeyWarning: 'Your API code. It will disappear after your leave this page!',
  confirm: 'Confirm',
  cancel: 'Cancel',
  issueWarningContent: 'You are about to issue a new API key.',
  issueWarningContent1:
    'You can only see the API key once. If you lose it, you must revoke it and create a new one.',
  issueWarningContent2:
    'Anyone with your API key can perform actions on behalf of your account. Keep it safe.',
  issueWarningContent3: 'Please confirm to proceed.',
  warning: 'Warning!',
  revokeWarningContent:
    'You are about to revoke an API key. This means the key will be permanently disabled and any applications (like your e-commerce platform) that are using this key will immediately lose access. Please make sure you really want to do this, as it cannot be undone.',
  reissueWarningContent:
    'You are about to create a new API key. This will automatically disable the current key, which means any applications (like your e-commerce platform) using the old key will immediately lose access.',
  reissueWarningContent1: 'Here are some important things to note:',
  reissueWarningContent2:
    'You can only view the new API key once. If you lose it, you’ll need to revoke it and create a new one.',
  reissueWarningContent3: 'Update all applications that use the API key with the new key value.',
  reissueWarningContent4:
    'Keep the new API key safe. Anyone with this key can access your account and make changes.',
  reissueWarningContent5: 'Please ensure you want to proceed, as this action cannot be undone.',
  alias: 'Alias',
  selectAccounts: 'Select account(s)',
  selectAccount: 'Select account',
  searchLocation: 'Search location',
  currency: 'Currency',
  accountsCurrencyError:
    ' It is not allowed to link the terminal to multiple accounts with the same currency.',
  deselectAll: 'Deselect all',
  linkedAccountsWarning:
    'You shall select at least one account. You can select multiple accounts only if each has a different currency.',
  unknownAccount: 'CLOSED ACCOUNT',
};
